import React, { useState } from "react";

const FilterWidget = ({ filters, setFilters, countdownFontSize, onCountdownSizeChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  return (
    <div className="fixed top-6 left-6 z-20 font-orbitron">
      <button
        onClick={(e) => {
          e.stopPropagation();
          e.currentTarget.blur(); // ✅ prevent button from keeping focus
          setIsOpen(!isOpen);
        }}
        className="bg-white text-black border border-black/20 px-4 py-2 rounded-md tracking-wider uppercase hover:border-red-500 hover:text-red-600 transition-all"
      >
        {isOpen ? "OPTIONS ◀" : "OPTIONS ▶"}
      </button>

      {isOpen && (
        <div
          className="mt-3 w-64 p-4 bg-white text-black border border-black/10 shadow-xl rounded-2xl tracking-wide max-h-[85vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()} // Prevent widget from collapsing when clicking inside
        >
          <h3 className="text-sm font-semibold mb-4 uppercase text-red-600">🚀 Launch Filters</h3>

          <label className="flex items-center mb-3 text-sm">
            <input
              type="checkbox"
              name="spacexOnly"
              checked={filters.spacexOnly}
              onChange={handleChange}
              className="mr-3 accent-red-600"
            />
            SpaceX
          </label>

          <label className="flex items-center mb-3 text-sm">
            <input
              type="checkbox"
              name="blueOriginOnly"
              checked={filters.blueOriginOnly}
              onChange={handleChange}
              className="mr-3 accent-red-600"
            />
            Blue Origin
          </label>

          <label className="flex items-center mb-3 text-sm">
            <input
              type="checkbox"
              name="rocketLabsOnly"
              checked={filters.rocketLabsOnly}
              onChange={handleChange}
              className="mr-3 accent-red-600"
            />
            Rocket Labs
          </label>

          <label className="flex items-center mb-3 text-sm">
            <input
              type="checkbox"
              name="unitedLaunchAllianceOnly"
              checked={filters.unitedLaunchAllianceOnly}
              onChange={handleChange}
              className="mr-3 accent-red-600"
            />
            United Launch Alliance
          </label>

          <label className="flex items-center mb-3 text-sm">
            <input
              type="checkbox"
              name="arianespaceOnly"
              checked={filters.arianespaceOnly}
              onChange={handleChange}
              className="mr-3 accent-red-600"
            />
            Arianespace
          </label>

          <label className="flex items-center mb-3 text-sm">
            <input
              type="checkbox"
              name="nasaOnly"
              checked={filters.nasaOnly}
              onChange={handleChange}
              className="mr-3 accent-red-600"
            />
            NASA
          </label>

          <h3 className="text-sm font-semibold mt-5 mb-4 uppercase text-red-600">⚙️ Launch Features</h3>

          <label className="flex items-center mb-3 text-sm cursor-pointer">
            <button
              onClick={() => setFilters((prev) => ({ ...prev, colourStatus: !prev.colourStatus }))}
              className={`relative flex-shrink-0 w-10 h-5 mr-3 rounded-full transition-colors duration-300 focus:outline-none ${filters.colourStatus ? "bg-red-600" : "bg-gray-300"}`}
            >
              <span className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform duration-300 ${filters.colourStatus ? "translate-x-5" : "translate-x-0"}`} />
            </button>
            Colour Status
          </label>

          <div className="mt-4 mb-1">
            <h3 className="text-sm font-semibold mb-2 uppercase text-red-600">🔡 Countdown Size</h3>
            <div className="flex items-center gap-3">
              <button
                onClick={() => onCountdownSizeChange(-0.5)}
                disabled={countdownFontSize <= 2}
                className="w-8 h-8 rounded-md border border-black/20 text-sm font-bold hover:border-red-500 hover:text-red-600 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
              >
                −
              </button>
              <span className="text-sm flex-1 text-center">{countdownFontSize}</span>
              <button
                onClick={() => onCountdownSizeChange(0.5)}
                disabled={countdownFontSize >= 6}
                className="w-8 h-8 rounded-md border border-black/20 text-sm font-bold hover:border-red-500 hover:text-red-600 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
              >
                +
              </button>
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default FilterWidget;
